import React from 'react';
import { Page, Document, StyleSheet, View, Font } from '@react-pdf/renderer';
import {
  Footer,
  Header,
  Invoicing,
  ItemDetails,
} from './components/HarvestSummaryReport';

Font.register({
  family: 'Trebuchet',
  fonts: [
    {
      src: require('assets/impact-report/trebucbd.ttf'),
      fontWeight: 'bold',
    },
    {
      src: require('assets/impact-report/trebuc.ttf'),
      fontWeight: 'normal',
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFD100',
    paddingTop: 24,
    paddingBottom: 20, // Reduced since footer is now in normal flow
    minHeight: '100%', // Ensure full height
  },
  tableContainer: {
    padding: 12, // Reduced from 18 to give more space
    paddingBottom: 4, // Further reduced to give maximum space for footer
    flex: 1, // Take available space
  },
});
type PdfHarvestSummaryReportProps = {
  data: any;
};

const HarvestSummaryPdfTemplate = ({ data }: PdfHarvestSummaryReportProps) => (
  <Document>
    {/* First Page - Item Details */}
    <Page size="A4" style={styles.page}>
      <Header reportData={data} />
      <View style={styles.tableContainer}>
        <ItemDetails reportData={data} />
      </View>
      <Footer />
    </Page>

    {/* Second Page - Invoicing */}
    <Page size="A4" style={styles.page}>
      <Header reportData={data} />
      <View style={styles.tableContainer}>
        <Invoicing reportData={data} />
      </View>
      <Footer />
    </Page>
  </Document>
);

export default HarvestSummaryPdfTemplate;
